import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-container container-fluid mt-5">
      <div className="row align-items-center">
        {/* Image Section */}
        <div className="col-lg-5 col-md-12 text-center">
          <div className="image-wrapper">
            <img
              src='/Assests/About_us.png'
              alt="We Help to Achieve Your Academic Goals"
              className="about-image"
            />
          </div>
        </div>

        {/* Text Section */}
        <div className="col-lg-6 col-md-12 text-center text-lg-start">
          <div className="about-title-wrapper">
            <h2 className="about-title">ABOUT US</h2>
          </div>
          <h3 className="trusted-by">Trusted By 200+ Satisfied Clients</h3>
          <p className="about-description">
            <strong>Sri Takshashila Gurukul</strong> is committed to providing an enriching
            educational roadmap for children, helping them achieve their academic goals and beyond.
          </p>
          <p className="about-description">
            Our mission is to empower students with the knowledge, skills, and mindset they need
            to excel in their studies and future endeavors.
          </p>
          <p className="about-description">
            Our vision is to embark on a journey of academic excellence, creative discovery, and
            personal growth. Let us guide you on a path to academic excellence and creative growth.
            Your success is our mission!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
